












































































//dataType声明
// 文本 = 1,
// 多行文本 = 2,
// 日期 = 3,
// 日期时间 = 4,
// 数字 = 5,
// 下拉框 = 6,
// 多选下拉框 = 7,
// 布尔 = 8,
// 时间选择 = 9,
// 日期区间 = 10,
// 选择月份 = 11
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
@Component({
  components:{}
})
export default class extends AbpBase{
    @Prop({type:Number,default:1}) pageId:Number;

    a = ''
    settingInfo:any = []
    created() {
        this.getSetting()   
    }
    async getSetting(){
        let data = {
            pageId:this.pageId
        }
        let res = await this.GetSetting(data)
        console.log(res)
        this.settingInfo = res.data.queryParaDto
        this.$emit('on-load',res.data.queryTypeDto,res.data.queryParaDto)
    }
    search(){
        this.$emit('on-search',this.settingInfo)
    }
}
